// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating TaskType records.
 * @typedef {object} TaskTypeWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [projectId] - Value for the projectId attribute.
 * @property {string | null} [name] - Value for the name attribute.
 * @property {boolean} [defaultForProject] - Value for the defaultForProject attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 */

/** @augments {DatabaseRecord<TaskTypeWriteAttributes>} */
export default class TaskTypeBase extends DatabaseRecord {
  /** @returns {typeof import("../models/task-type.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/task-type.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  projectId() { return this.readAttribute("projectId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setProjectId(newValue) { return this._setColumnAttribute("projectId", newValue) }

  /** @returns {boolean} */
  hasProjectId() { return this._hasAttribute(this.projectId()) }

  /** @returns {string | null} */
  name() { return this.readAttribute("name") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setName(newValue) { return this._setColumnAttribute("name", newValue) }

  /** @returns {boolean} */
  hasName() { return this._hasAttribute(this.name()) }

  /** @returns {boolean} */
  defaultForProject() { return this.readAttribute("defaultForProject") }

  /**
   * @param {boolean} newValue
   * @returns {void}
   */
  setDefaultForProject(newValue) { return this._setColumnAttribute("defaultForProject", newValue) }

  /** @returns {boolean} */
  hasDefaultForProject() { return this._hasAttribute(this.defaultForProject()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task-type.js").default, typeof import("../models/task.js").default>}
   */
  tasks() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/task-type.js").default, typeof import("../models/task.js").default>} */ (this.getRelationshipByName("tasks")) }

  /**
   * @returns {Array<import("../models/task.js").default>}
   */
  tasksLoaded() { return /** @type {Array<import("../models/task.js").default>} */ (this.getRelationshipByName("tasks").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/task.js").default>>}
   */
  loadTasks() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/task.js").default>>}
   */
  tasksOrLoad() { return /** @type {Promise<Array<import("../models/task.js").default>>} */ (this.relationshipOrLoad("tasks")) }

  /**
   * @abstract
   * @param {Array<import("../models/task.js").default>} newModels
   * @returns {void}
   */
  setTasks(newModels) { void newModels; throw new Error("Not implemented") }
}
